<template>
  <div>
    <generic-container
      :title="$t('deployment management')"
      icon="layer group"
      :searchable="false"
      :configurable="true"
      v-bind:configure_modal="configure_modal"
      :header_buttons="header_buttons"
      v-on:add="add"
      v-on:filter="filter"
      ref="container"
    >
      <div class="ui list">
        <div
          class="item"
          v-for="(partition, index) in partitions"
          :key="index"
          @click="toggle_partition(index)"
        >
          <i class="layer group icon"></i>
          <div class="content">
            <div class="header">{{ partition.name }}</div>
            <div class="list" ref="partition_toggle_target">
              <div
                class="item"
                v-for="(group, idex) in partition.groups"
                :key="idex"
                @click.stop="toggle_group"
              >
                <i class="setting icon"></i>
                <div class="content">
                  <div class="header">{{ groupName(group.id) }}</div>
                  <div
                    class="list"
                    ref="group_toggle_target"
                    :data-id="'_' + index + '_' + idex"
                  >
                    <div
                      class="item"
                      v-for="(process, idx) in group.processes"
                      :key="idx"
                      @click.stop="select_process(process)"
                    >
                      <i
                        class="bullseye icon"
                        :class="{ green: process.is_default }"
                      ></i>
                      <div class="content">
                        <div class="header">
                          {{ $t("version") }} {{ process.deployment.version }}
                        </div>
                        <div class="description">
                          {{
                            process.deployment.create_date
                              | formatDate(
                                enterprise_setup.detailed_date_format,
                              )
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </generic-container>
  </div>
</template>

<script>
import { local_api, error_toast, clone, enterprise_setup } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./NgineCoreConfigureModal";
import _ from "lodash";

export default {
  name: "DeploymentManagement",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      partitions: [],
      all_partitions: [],
      configure_modal: ConfigureModal,
      header_buttons: [
        {
          click: this.refresh,
          icon: "refresh",
          color: "green",
        },
      ],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    add() {},
    groupName(id) {
      // eslint-disable-next-line no-unused-vars
      var name = "[unknown]";
      this.partitions.map((p) => {
        p.groups.map((g) => {
          if (g.id == id && g.processes.length > 0) name = g.processes[0].name;
        });
      });
      return name;
    },
    filter(filter) {
      console.log(filter);
      // if (filter == "") this.partitions = this.all_partitions;
      // else
      //   this.partitions = this.all_partitions.filter(n => {
      //     return n.groups.filter(g => {
      //       return g.processes.find(p => {
      //         return p.name.toUpperCase().includes(filter.toUpperCase());
      //       });
      //     });
      //   });
    },
    toggle_partition(index) {
      window
        .jQuery(this.$refs.partition_toggle_target[index])
        .slideToggle("fast");
    },
    toggle_group($event) {
      // let idx = partitionIdx
      let target = window
        .jQuery($event.srcElement)
        .parent()
        .find(".list");
      target.slideToggle("fast");
      // window.jQuery(this.$refs.group_toggle_target[index]).slideToggle("fast");
    },
    select_process(process) {
      this.$emit("select_process", process);
    },
    refresh() {
      this.getData();
    },
    getData() {
      let vm = this;
      vm.$refs.container.set_loading(true);
      local_api(vm, "post", "/ngine_core/partition/do-get-list-with-processes")
        .then((partitions) => {
          let _partitions = partitions
            .sort(function(a, b) {
              if (a.name > b.name) return 1;
              if (b.name > a.name) return -1;
              return 0;
            })
            .map((partition) => {
              partition.processes = [];
              partition.ngn_deployments.map((deployment) => {
                deployment.ngn_processes.map((pr) => {
                  pr.deployment = {
                    version: deployment.version,
                    create_date: deployment.create_date,
                  };

                  partition.processes.push(pr);
                  delete partition.ngn_deployments;
                });
              });
              return partition;
            })
            .map((partition) => {
              partition.groups = [];
              let grouped = _.groupBy(partition.processes, (prc) => {
                return prc.source_process_uuid;
              });
              Object.keys(grouped).map((k) => {
                partition.groups.push({ id: k, processes: grouped[k] });
              });
              delete partition.processes;
              return partition;
            });
          vm.partitions = _partitions;
          vm.all_partitions = clone(_partitions);
          vm.$refs.container.set_loading(false);
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    remove_process() {
      this.refresh();
      // this.partitions.map(p => {
      //   p.groups.map(g => {
      //     let idx = g.processes.findIndex(_p => _p.uuid == process_uuid);
      //     if (idx > -1) g.processes.splice(idx, 1);
      //   });
      // });
    },
    process_default(process_uuid) {
      this.partitions.map((p) => {
        p.groups.map((g) => {
          let idx = g.processes.findIndex((_p) => _p.uuid == process_uuid);
          if (idx > -1) {
            g.processes.map((pr) => {
              pr.is_default = false;
            });
            g.processes[idx].is_default = true;
          }
        });
      });
    },
  },
  mounted() {
    this.getData();
  },
  watch: {},
};
</script>
